var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.69231C2 8.66667 4 8.66667 4 9.69231L4 17.8974C4 19.0303 4.89543 19.9487 6 19.9487L18 19.9487C19.1046 19.9487 20 19.0303 20 17.8974L20 9.69231C20 8.66667 22 8.66667 22 9.69231L22 17.8974C22 20.1632 20.2091 22 18 22L6 22C3.79086 22 2 20.1632 2 17.8974L2 9.69231Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7005 2.29374C12.6062 2.19871 12.498 2.12674 12.3828 2.07782C12.2657 2.02805 12.1375 2.00041 12.003 2L12 2L11.997 2C11.7421 2.00078 11.4874 2.10091 11.2929 2.3004L8.29289 5.37733C7.90237 5.77786 7.90237 6.42726 8.29289 6.8278C8.68342 7.22834 9.31658 7.22834 9.70711 6.8278L11 5.50176L11 16.359C11 16.9254 11.4477 17.3846 12 17.3846C12.5523 17.3846 13 16.9254 13 16.359L13 5.50176L14.2929 6.8278C14.6834 7.22834 15.3166 7.22834 15.7071 6.8278C16.0976 6.42726 16.0976 5.77786 15.7071 5.37733L12.7078 2.30113L12.7005 2.29374Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9ce7115eb7abf3c33695fd2756453ce7.svg";
export { ForwardRef as ReactComponent };